import { render, staticRenderFns } from "./form-edit.vue?vue&type=template&id=a9790afc&scoped=true&"
import script from "./form-edit.vue?vue&type=script&lang=js&"
export * from "./form-edit.vue?vue&type=script&lang=js&"
import style0 from "./form-edit.vue?vue&type=style&index=0&id=a9790afc&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9790afc",
  null
  
)

export default component.exports